<template>
    <v-dialog :value="value" width="450" @click:outside="$emit('cancel')">
      <v-card>
        <v-card-title>
          Confirm Dates
        </v-card-title>
        <v-card-text>
          <div class="mb-6" v-if="pastDates.length > 0">
            <p>- The following selected dates are before the current day:</p>
            <v-row class="ml-2" v-for="obj of pastDates" :key="obj.label + obj.date">
              <v-col class="font-weight-bold red--text py-0">
                {{ obj.label }}
              </v-col>
              <v-col class="font-weight-bold red--text py-0">
                {{ formatDate(obj.date) }}
              </v-col>
            </v-row>
          </div>
          <div class="mb-6" v-if="tprDatesLessThanThreeWeeks">
            <p>- TPR promotion is less than 3 weeks in length.</p>
            <v-row class="ml-2">
              <v-col class="font-weight-bold red--text py-0">
                 Start Date: {{ formatDate(tprStartDate) }}
              </v-col>
              <v-col class="font-weight-bold red--text py-0">
                End Date: {{ formatDate(tprEndDate) }}
              </v-col>
            </v-row>
          </div>
          <p>Proceed?</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="grey darken-1" text @click="$emit('cancel')">
            Cancel
          </v-btn>
          <v-btn color="primary" @click="confirm">
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  export default {
    name: 'ConfirmDatesDialog',
    props: {
      value: Boolean,
      pastDates: Array,
      tprDatesLessThanThreeWeeks: Boolean,
      tprStartDate: String,
      tprEndDate: String,
    },
    methods: {
      confirm() {
        this.$emit('openConfirm')
      },
      formatDate(date) {
          const [year, month, day] = date.split('-')
          return `${month}/${day}/${year}`
      }
    }
  }
  </script>